module.exports = __webpack_public_path__ + "static/media/upload_placeholder.ba4d01f5.jpg";